var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{class:_vm.platformClass(),style:(_vm.theme)},[(!_vm.isInitial)?_c('AppLoading'):_c('div',[_c('Header',{on:{"onMenuExpandedChanged":_vm.onMenuExpandedChanged}}),_vm._v(" "),_c('v-main',{style:({
        'padding-left': _vm.isMenuExpanded ? '256px' : '56px',
      })},[_c('v-container',[_c('nuxt')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }